import { Box } from '@mui/material'
import React, { useLayoutEffect, useRef, useState } from 'react'

// Renders <li> only if the child actually produced content (hides li when child returns null).
const OptionalListItem: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const wrapperRef = useRef<HTMLElement>(null)
  const [hide, setHide] = useState(false)

  // After render, check the DOM: when returning null, React leaves only comment node
  useLayoutEffect(() => {
    const el = wrapperRef.current
    if (!el) return
    const hasContent = Array.from(el.childNodes).some(n => n.nodeType !== Node.COMMENT_NODE)
    if (!hasContent) setHide(true) // If the child returned null, hide the child element
  }, [])

  if (hide) return null

  return (
    <Box component='li' ref={wrapperRef}>
      {children}
    </Box>
  )
}

export default OptionalListItem
